import React from 'react';
import ReactJson from 'react-json-view';
import constate from 'constate';
import { useSearchParams } from 'react-router-dom';

import Card from '~/components/Card';
import If from '~/components/If';

import { ScreenWidget } from '~/widgets';
import appWithSettings from '~/hocs/appSettings';
import withProvider from '~/hocs/withProvider';

import { useProviderFactory } from '~/hooks/useProviderFactory';

import initialObj from './INITIAL_OBJ.json';

const useSnOverride = () => useProviderFactory();

const [SnOverrideProvider, useSnOverrideState, useSnOverrideEffects] = constate(
  useSnOverride,
  (value) => value.state,
  (value) => value.effects,
);

export const SnOverridePage = () => {
  const [searchParams] = useSearchParams();

  const { store } = useSnOverrideState();
  const { setValue } = useSnOverrideEffects();

  const hasStore = !!searchParams.get('store');

  return (
    <>
      <ScreenWidget
        widgetFieldProps={{
          currentStore: store,
          sendValue: (payload) => setValue(payload),
        }}
        data={initialObj as any}
      />

      <If condition={window.location.origin.includes('localhost') || hasStore}>
        <Card className="mb-3" title="Store" defaultOpened={false}>
          <ReactJson src={store} />
        </Card>
      </If>
    </>
  );
};

export const SnOverride = appWithSettings({
  title: 'Payoff Builder',
  description: '',
})(withProvider(SnOverrideProvider)(SnOverridePage));
